import React, {useEffect, useState} from "react";
import * as Const from "../Const";
import {calculateBounds} from "../utils/OwnMath";
import {Polygon, Polyline, Tooltip} from 'react-leaflet'
import {SHOW_UNFINISHED_STUFF} from "../Const";
import {CloseButton} from "react-bootstrap";
import useMqttClient from "../hooks/useMqttClient";

const TAG = "PPv2";

const hullLinePathOptions = { color: '#ffa500', weight: 1, dashArray: null };
const activeHullLinePathOptions = { color: '#cc4200', weight: 1.5, dashArray: null };
const selectedMachineActiveHullLinePathOptions = { color: '#aa0000', weight: 1.5, dashArray: null };

const selectedHullLinePathOptions = { color: '#2b00d5', weight: 1.5, dashArray: null };
const selectedHiddenHullLinePathOptions = { color: '#2b00d5', weight: 0.4, dashArray: '4,4' };

const trajectoryLinePathOptions = { color: '#000000', weight: 0.25, dashArray: null };


function calculateParcelTooltipPosition(parcel) {
    if (parcel['center']) {
        return parcel['center'];
    } else {
        const { min, max } = calculateBounds(parcel['hull']);
        return [min[0], 0.5 * (min[1] + max[1])];
    }
}


function ParcelPolygon({mqttClient, parcel, selectedFieldName, onParcelClicked, selectedMachineName, workConfigurations, paneName, isInteractive}) {

    const [isButtonDisabled, setButtonDisabled] = useState(false);

    let options = hullLinePathOptions;
    if (parcel.is_visible) {
        if (parcel.field_name === selectedFieldName) {
            options = selectedHullLinePathOptions
        } else if (selectedMachineName && parcel.field_name === workConfigurations[selectedMachineName]) {
            options = selectedMachineActiveHullLinePathOptions;
        } else if (Object.values(workConfigurations).some(n => n === parcel.field_name)) {
            options = activeHullLinePathOptions;
        }
    } else if (parcel.field_name === selectedFieldName) {
        options = selectedHiddenHullLinePathOptions;
    }

    return (
        <>
            <Polygon pathOptions={options}
                     pane={paneName}
                     interactive={isInteractive}
                     positions={parcel['hull']}
                     eventHandlers={
                         {
                             click: () => {
                                 if (parcel.field_name !== selectedFieldName) onParcelClicked(parcel)
                             }
                         }
                     }
            >
                {parcel['field_name'] === selectedFieldName
                    ? <Tooltip permanent interactive={true} autoClose={false} closeOnEscapeKey={false}
                               closeOnClick={false} direction={"bottom"} position={calculateParcelTooltipPosition(parcel)}>
                        <div className={"d-flex flex-column align-items-start p-2"}>
                            <div className={"d-flex flex-row pb-1"}>
                                <div className={""}><strong>{decodeURIComponent(parcel['parcel_name'])}</strong></div>
                                <div className={"ps-3 pe-0"}><CloseButton onClick={() => onParcelClicked(parcel)}/></div>
                            </div>
                            <div className={""}>{decodeURIComponent(parcel['machine'])}</div>
                            {
                                selectedMachineName === parcel['machine']
                                    ? <>
                                        {
                                            parcel.field_name === workConfigurations[selectedMachineName]
                                                ? <div>Selected</div>
                                                : <button className={"btn btn-sm btn-outline-primary" + (isButtonDisabled ? " disabled" : "")}
                                                          onClick={() => {
                                                              let topic = parcel['machine'] + "/" + Const.MQTT_PUBLISH_CMD_SELECT_PARCEL;
                                                              setButtonDisabled(true);
                                                              setTimeout(() => {setButtonDisabled(false)}, 5000);
                                                              console.log(topic, parcel['list_index']);
                                                              mqttClient?.publish(topic, parcel['list_index'], {qos: 0, retain: false});
                                                          }}
                                                >Select</button>
                                        }
                                    </>
                                    : null
                            }
                        </div>
                    </Tooltip>
                    : <Tooltip direction={"bottom"} position={calculateParcelTooltipPosition(parcel)}>
                        {decodeURIComponent(parcel['parcel_name'])}
                    </Tooltip>
                }

            </Polygon>
            {parcel['trajectory']
                ? <Polyline pathOptions={trajectoryLinePathOptions} positions={parcel['trajectory']}/>
                : null
            }
        </>
    );
}


function OverviewMapParcelPolygonsV2({mqttClient, parcelsWithVisibility, workConfigurations, selectedMachineName, selectedFieldName, onParcelClicked}) {

    const [updates, setUpdates] = useState(0);

    useEffect(() => {
        setUpdates(updates => updates + 1);
    }, [parcelsWithVisibility, workConfigurations, selectedFieldName, selectedMachineName, onParcelClicked]);

    // const workConfigFieldNames = useMemo(() => {
    //     // console.log("MAPv3 work", JSON.stringify(workConfigurations));
    //     return Object.values(workConfigurations).filter(item => item !== undefined);
    // }, [workConfigurations]);


    return(
        <>
            {parcelsWithVisibility
                .filter(parcel => parcel.is_visible && parcel.field_name !== selectedFieldName)
                .map(parcel => {
                    return <ParcelPolygon
                        key={parcel.machine + parcel.field_name}
                        mqttClient={mqttClient}
                        parcel={parcel}
                        selectedFieldName={selectedFieldName}
                        selectedMachineName={selectedMachineName}
                        workConfigurations={workConfigurations}
                        onParcelClicked={onParcelClicked}
                        paneName={Const.PANE_NAME_PARCELS}
                        isInteractive={true}
                    />
                })
            }

            {parcelsWithVisibility
                .filter(parcel => parcel.field_name === selectedFieldName)
                .map(parcel => {
                    return <ParcelPolygon
                        key={parcel.machine + parcel.field_name}
                        mqttClient={mqttClient}
                        parcel={parcel}
                        selectedFieldName={selectedFieldName}
                        selectedMachineName={selectedMachineName}
                        workConfigurations={workConfigurations}
                        onParcelClicked={onParcelClicked}
                        paneName={Const.PANE_NAME_SELECTED_PARCELS}
                        isInteractive={false}
                    />
                })
            }

            {SHOW_UNFINISHED_STUFF ?
                <div className={"position-absolute end-0 bottom-0 m-2 bg-light"} style={{zIndex: Const.PANEL_OVERLAY_Z + 200}}>[{TAG} {updates}]</div>
                : null
            }
        </>
    );

}


export default OverviewMapParcelPolygonsV2;